import { render, staticRenderFns } from "./NovaDynaForm.vue?vue&type=template&id=5669026d&"
import script from "./NovaDynaForm.vue?vue&type=script&lang=js&"
export * from "./NovaDynaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports